<template>
  <v-app id="inspire">
    <v-navigation-drawer v-if="$route.meta.isHome === 1" v-model="drawer" app>
      <v-list class="justify-center">
        <v-list-item class="d-flex justify-center">
          <v-list-item-avatar>
            <v-img contain src="./assets/logo_sultan_agung.png"></v-img>
          </v-list-item-avatar>
        </v-list-item>

        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="text-h6 text-center">
              {{ currentUser.nama }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-center">{{
              currentUser.email
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list nav dense>
        <router-link
          v-if="hasPermission('view', 'Dashboard')"
          to="/dashboard"
          style="text-decoration: none; color: inherit"
        >
          <v-list-item link>
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item>
        </router-link>

        <router-link
          v-if="hasPermission('view', 'SDMMedis')"
          to="/nakes"
          style="text-decoration: none; color: inherit"
        >
          <v-list-item link>
            <v-list-item-icon>
              <v-icon>mdi-account-box</v-icon>
            </v-list-item-icon>
            <v-list-item-title>SDM Medis</v-list-item-title>
          </v-list-item>
        </router-link>

        <router-link
          v-if="hasPermission('view', 'SDMMedis')"
          to="/karyawan"
          style="text-decoration: none; color: inherit"
        >
          <v-list-item link>
            <v-list-item-icon>
              <v-icon>mdi-account-box</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Karyawan</v-list-item-title>
          </v-list-item>
        </router-link>

        <v-list-item
          v-if="hasPermission('view', 'InformasiBroadcast')"
          to="/informasi-broadcast"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-bell-ring</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Informasi Broadcast</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="hasPermission('view', 'JadwalPraktekDokter')"
          to="/jadwal-praktek-dokter"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-calendar-clock</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Jadwal Praktek Dokter</v-list-item-title>
        </v-list-item>

        <v-list-group v-if="hasPermission('view', 'Telemedicine')" no-action>
          <template #activator>
            <v-list-item-icon>
              <v-icon>mdi-doctor</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Telemedicine</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-if="hasPermission('view', 'TimTelemedicine')" link>
            <v-list-item-content>
              <router-link
                to="/dokter-telemedicine"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Tim Telemedicine</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'JadwalKonsultasi')" link>
            <v-list-item-content>
              <router-link
                to="/jadwal-konsultasi"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Jadwal Konsultasi</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="hasPermission('view', 'RiwayatKonsultasiOnline')"
            link
          >
            <v-list-item-content>
              <router-link
                to="/history-chats"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Riwayat Konsultasi Online</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'Pasien')" link>
            <v-list-item-content>
              <router-link
                to="/pasien"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Pasien</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'SettingTelemedicine')" link>
            <v-list-item-content>
              <router-link
                to="/setting-telemedicine"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Setting Telemedicine</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="hasPermission('view', 'TermAndConditionTelemedicine')"
            link
          >
            <v-list-item-content>
              <router-link
                to="/term-and-condition-telemedicine"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title
                  >Term and Condition Telemedicine</v-list-item-title
                >
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-group
            v-if="hasPermission('view', 'MasterObat')"
            no-action
            sub-group
          >
            <template #activator>
              <v-list-item-content>
                <v-list-item-title>Master Obat</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item v-if="hasPermission('view', 'Obat')" link>
              <v-list-item-content>
                <router-link
                  to="/obat"
                  style="text-decoration: none; color: inherit"
                >
                  <v-list-item-title>Obat</v-list-item-title>
                </router-link>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="hasPermission('view', 'Supplier')" link>
              <v-list-item-content>
                <router-link
                  to="/supplier"
                  style="text-decoration: none; color: inherit"
                >
                  <v-list-item-title>Supplier</v-list-item-title>
                </router-link>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="hasPermission('view', 'KategoriObat')" link>
              <v-list-item-content>
                <router-link
                  to="/kategori-obat"
                  style="text-decoration: none; color: inherit"
                >
                  <v-list-item-title>Kategori Obat</v-list-item-title>
                </router-link>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="hasPermission('view', 'SatuanUnitObat')" link>
              <v-list-item-content>
                <router-link
                  to="/satuan-unit-obat"
                  style="text-decoration: none; color: inherit"
                >
                  <v-list-item-title>Satuan Unit Obat</v-list-item-title>
                </router-link>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list-group>

        <v-list-group v-if="hasPermission('view', 'Telemedicine')" no-action>
          <template #activator>
            <v-list-item-icon>
              <v-icon>mdi-doctor</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Tes Psikologis</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-if="hasPermission('view', 'TimTelemedicine')" link>
            <v-list-item-content>
              <router-link
                to="/psikologis/disc"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Disc</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'TimTelemedicine')" link>
            <v-list-item-content>
              <router-link
                to="/psikologis/loyalitas"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Loyalitas</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group v-if="hasPermission('view', 'WebContent')" no-action>
          <template #activator>
            <v-list-item-icon>
              <v-icon>mdi-web</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Web Content</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-if="hasPermission('view', 'AgendaPelatihan')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/agenda-pelatihan"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Agenda Pelatihan</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'Artikel')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/artikel"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Artikel (Healthpedia)</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'KategoriArtikel')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/kategori-artikel"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Kategori Artikel</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'Berita')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/berita"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Berita</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'KategoriBerita')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/kategori-berita"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Kategori Berita</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'Pengurus')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/pengurus"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Pengurus</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'Sejarah')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/sejarah"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Sejarah</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'SettingRS')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/setting-rs"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Setting RS</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'StrukturOrganisasi')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/struktur-organisasi"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Struktur Organisasi</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'SummaryLayanan')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/summary-layanan"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Summary Layanan</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'Testimoni')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/testimoni"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title
                  >Testimoni ( Expertise Meets Compassions)</v-list-item-title
                >
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'VisiMisi')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/visi-misi"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Visi Misi</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'HubungiKami')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/hubungi-kami"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Hubungi Kami</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'Karir')" link>
            <v-list-item-content>
              <router-link
                to="/webcontent/karir"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Karir</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group v-if="hasPermission('view', 'Master')" no-action>
          <template #activator>
            <v-list-item-icon>
              <v-icon>mdi-table</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Master</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-if="hasPermission('view', 'RumahSakit')" link>
            <v-list-item-content>
              <router-link
                to="/rumah-sakit"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Rumah Sakit</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'KlinikEksekutif')" link>
            <v-list-item-content>
              <router-link
                to="/klinik-eksekutif"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Klinik Eksekutif</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'HomeCare')" link>
            <v-list-item-content>
              <router-link
                to="/home-care"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Home Care</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'MCU')" link>
            <v-list-item-content>
              <router-link
                to="/mcu"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>MCU</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'Bank')" link>
            <v-list-item-content>
              <router-link
                to="/bank"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Bank</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'Jabatan')" link>
            <v-list-item-content>
              <router-link
                to="/master/jabatanlist"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Jabatan</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'Komunitas')" link>
            <v-list-item-content>
              <router-link
                to="/komunitas"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Komunitas</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'LayananSuperior')" link>
            <v-list-item-content>
              <router-link
                to="/master-layanan-superior"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Layanan Superior</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'Partnership')" link>
            <v-list-item-content>
              <router-link
                to="/master-partnership"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Partnership</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'Poli')" link>
            <v-list-item-content>
              <router-link
                to="/poli"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Poli</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="hasPermission('view', 'Profesi')" link>
            <v-list-item-content>
              <router-link
                to="/profesi"
                style="text-decoration: none; color: inherit"
              >
                <v-list-item-title>Profesi</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>

          <v-list-group
            v-if="hasPermission('view', 'MasterUser')"
            no-action
            sub-group
          >
            <template #activator>
              <v-list-item-content>
                <v-list-item-title>Master User</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item v-if="hasPermission('view', 'User')" link>
              <v-list-item-content>
                <router-link
                  to="/user"
                  style="text-decoration: none; color: inherit"
                >
                  <v-list-item-title>User</v-list-item-title>
                </router-link>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="hasPermission('view', 'Role')" link>
              <v-list-item-content>
                <router-link
                  to="/role"
                  style="text-decoration: none; color: inherit"
                >
                  <v-list-item-title>Role</v-list-item-title>
                </router-link>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list-group>

        <router-link to="/" style="text-decoration: none; color: inherit">
          <v-list-item link @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </router-link>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar v-if="$route.meta.isHome === 1" color="primary" dark app dense>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>RS Sultan Agung </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <router-view></router-view>
  </v-app>
</template>

<script>
import WebsiteService from "./services/WebsiteService";

export default {
  data: () => ({
    drawer: null,
    currentUser: {
      nama: "",
      email: "",
    },

    env_komisariat: "",
    header_image: "",
    komisariat_id: 0,
  }),
  mounted() {
    this.loadWebsiteInfo();

    var myUser = JSON.parse(
      localStorage.getItem(process.env.VUE_APP_USER_PREFIX),
    );

    if (myUser) {
      this.currentUser = myUser;
    }
  },

  methods: {
    logout: async function () {
      this.$store.dispatch("logout").then(() =>
        this.$router.push("/").catch((err) => {
          console.log(err);
        }),
      );
    },

    loadWebsiteInfo() {
      WebsiteService.websiteInfo(window.location.hostname)
        .then((res) => {
          this.env_komisariat = res.data.info.komisariat;
          this.komisariat_id = res.data.info.komisariat_id;
          this.header_image = res.data.info.header_image;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    hasPermission(actionToCheck, subjectToCheck) {
      const permissions = JSON.parse(
        localStorage.getItem("SULTAN_AGUNG_PERMISSIONS"),
      );
      return permissions.some(
        (permission) =>
          permission.action === actionToCheck &&
          permission.subject === subjectToCheck,
      );
    },
  },
};
</script>
